<template>
  <div class="uncompleted">
    <v-overlay
      :value="conceptsLoading || kitchensLoading || platformsLoading || uncompletedLoading"
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-tabs
      v-model="tab"
      color="red accent-2"
      background-color="grey lighten-4"
      :centered="false"
      height="75px"
      show-arrows
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="[key, value] of Object.entries(sortedTabs)"
        :key="key"
        :href="`#tab-${key}`"
        class="pt-2"
      >
        <v-avatar size="50px" tile>
          <v-img :src="getElementByUuid(key, concepts).logo" contain class />
        </v-avatar>
        <span class="ml-2">{{ getElementByUuid(key, concepts).label }} ({{value.length}})</span>
      </v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="[key, value] of Object.entries(sortedTabs)"
          :key="key"
          :value="`tab-${key}`"
        >
          <UncompletedTab
            :normalizationLoading="normalizationLoading"
            :conceptUuid="key"
            :concepts="concepts"
            :progress="progress"
            :orders="value"
            v-on:stop="stop"
            v-on:normalizeConcept="normalizeConcept"
            v-on:normalizeOrder="normalizeOrder"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import UncompletedTab from "@/components/Uncompleted/UncompletedTab";

export default {
  components: { UncompletedTab },
  data: () => {
    return {
      tab: "",
      search: "",
      normalizationLoading: false,
      currentNormalization: 0,
      normalizationNumber: 1,
      stop: false,
    };
  },
  computed: {
    ...mapState({
      uncompleted: (state) => state.orders.uncompleted,
      uncompletedLoading: (state) => state.orders.fetchUncompleted.pending,
      concepts: (state) => state.restaurant.concepts,
      conceptsLoading: (state) => state.restaurant.fetchAllConcepts.pending,
      kitchens: (state) => state.restaurant.kitchens,
      kitchensLoading: (state) => state.restaurant.fetchAllKitchens.pending,
      platforms: (state) => state.restaurant.platforms,
      platformsLoading: (state) => state.restaurant.fetchAllPlatforms.pending,
    }),
    tabs() {
      let tabs = _.groupBy(this.uncompleted, "concept_uuid");
      return Object.keys(tabs).sort();
    },
    sortedTabs() {
      return _.groupBy(this.uncompleted, "concept_uuid");
    },
    progress() {
      return (this.currentNormalization / this.normalizationNumber) * 100;
    },
  },
  methods: {
    ...mapActions({
      setError: "setError",
    }),
    ...mapActions("orders", {
      fetchUncompleted: "fetchUncompleted",
      normalize: "normalize",
    }),
    ...mapActions("restaurant", {
      fetchAllConcepts: "fetchAllConcepts",
      fetchAllKitchens: "fetchAllKitchens",
      fetchAllPlatforms: "fetchAllPlatforms",
    }),
    getElementByUuid(uuid, list) {
      return list.find((obj) => obj.uuid === uuid);
    },
    normalizeOrder(uuid) {
      this.normalize({ uuid: uuid })
        .then(() => {
          this.fetchUncompleted().catch((error) => {
            this.setError(error);
          });
        })
        .catch((error) => {
          this.setError(error);
        });
    },
    async normalizeConcept(conceptUuid) {
      this.stop = false;
      let filteredUncompleted = this.sortedTabs[conceptUuid];
      this.normalizationLoading = true;
      this.normalizationNumber = filteredUncompleted.length;
      for (let order in filteredUncompleted) {
        if (!this.stop) {
          await this.normalize({ uuid: filteredUncompleted[order].uuid })
            .then(() => {
              this.currentNormalization += 1;
            })
            .catch((error) => {
              this.setError(error);
            });
        }
      }
      this.currentNormalization = 0;
      this.normalizationNumber = 1;
      this.normalizationLoading = false;
      this.fetchUncompleted().catch((error) => {
        this.setError(error);
      });
    },
  },
  created() {
    this.fetchUncompleted().catch((error) => {
      this.setError(error);
    });
    this.fetchAllConcepts().catch((error) => {
      this.setError(error);
    });
    this.fetchAllKitchens().catch((error) => {
      this.setError(error);
    });
    this.fetchAllPlatforms().catch((error) => {
      this.setError(error);
    });
  },
};
</script>
